export const configurations = {
    'BESS2300E.4': {
        capacity: 8.93,
        power: 4.8,
        numberOfStrings: 4,
        productName: 'BESS2300E.4',
        numberOfPCS: 4,
        length: '21,6 m / 70,8 ft',
        width: '2,44 m / 8 ft',
        weight: '<25 t / 55.115 lbs per container',
        image: 'images/2300e.4.jpg',
    },
    'BESS2300E.3': {
        capacity: 6.7,
        power: 3.6,
        numberOfStrings: 3,
        productName: 'BESS2300E.3',
        numberOfPCS: 3,
        length: '16,2 m / 53,1 ft',
        width: '2,44 m / 8 ft',
        weight: '<25 t / 55.115 lbs per container',
        image: 'images/2300e.3.jpg',
    },
    'BESS1600P.4': {
        capacity: 6.25,
        power: 4.8,
        numberOfStrings: 4,
        productName: 'BESS1600P.4',
        numberOfPCS: 4,
        length: '15,84 m / 52 ft',
        width: '2,44 m / 8 ft',
        weight: '87,76 t / 193.478 lbs',
        image: 'images/1600p.4.jpg',
    },
    'BESS1600E.4': {
        capacity: 6.25,
        power: 2.4,
        numberOfStrings: 4,
        productName: 'BESS1600E.4',
        numberOfPCS: 4,
        length: '15,84 m / 52 ft',
        width: '2,44 m / 8 ft',
        weight: '86,36 t / 190.391 lbs',
        image: 'images/1600e.4.jpg',
    },
    'BESS1600P.3': {
        capacity: 4.69,
        power: 3.6,
        numberOfStrings: 3,
        productName: 'BESS1600P.3',
        numberOfPCS: 3,
        length: '11,89 m / 39 ft',
        width: '2,44 m / 8 ft',
        weight: '65,84 t / 145.152 lbs',
        image: 'images/1600p.3.jpg',
    },
    'BESS1600E.3': {
        capacity: 4.69,
        power: 1.8,
        numberOfStrings: 3,
        productName: 'BESS1600E.3',
        numberOfPCS: 3,
        length: '11,89 m / 39 ft',
        width: '2,44 m / 8 ft',
        weight: '64,79 t / 142.837 lbs',
        image: 'images/1600e.3.jpg',
    },
    'BESS2300E.2': {
        capacity: 4.47,
        power: 2.4,
        numberOfStrings: 2,
        productName: 'BESS2300E.2',
        numberOfPCS: 2,
        length: '10,8 m / 35,4 ft',
        width: '2,44 m / 8 ft',
        weight: '<25 t / 55.115 lbs per container',
        image: 'images/2300e.2.jpg',
    },
    'BESS1600P.2': {
        capacity: 3.120,
        power: 2.4,
        numberOfStrings: 2,
        productName: 'BESS1600P.2',
        numberOfPCS: 2,
        length: '7,92 m / 26 ft',
        width: '2,44 m / 8 ft',
        weight: '43,92 t / 96.827 lbs',
        image: 'images/1600p.2.jpg',
    },
    'BESS1600E.2': {
        capacity: 3.120,
        power: 1.2,
        numberOfStrings: 2,
        productName: 'BESS1600E.2',
        numberOfPCS: 1,
        length: '7,92 m / 26 ft',
        width: '2,44 m / 8 ft',
        weight: '43,22 t / 95.283 lbs',
        image: 'images/1600e.2.jpg',
    },
    'BESS2300E.1': {
        capacity: 2.23,
        power: 1.2,
        numberOfStrings: 1,
        productName: 'BESS2300E.1',
        numberOfPCS: 1,
        length: '5,4 m / 17,7 ft',
        width: '2,44 m / 8 ft',
        weight: '<25 t / 55.115 lbs per container',
        image: 'images/2300e.1.jpg',
    },
    'BESS1600P.1': {
        capacity: 1.560,
        power: 1.2,
        numberOfStrings: 1,
        productName: 'BESS1600P.1',
        numberOfPCS: 1,
        length: '3,96 m / 13 ft',
        width: '2,44 m / 8 ft',
        weight: '22,00 t / 48.501 lbs',
        image: 'images/1600p.1.jpg',
    },
    'BESS1600E.1': {
        capacity: 1.560,
        power: 0.6,
        numberOfStrings: 1,
        productName: 'BESS1600E.1',
        numberOfPCS: 1,
        length: '3,96 m / 13 ft',
        width: '2,44 m / 8 ft',
        weight: '21,65 t / 47.730 lbs',
        image: 'images/1600e.1.jpg',
    },
};